import { render, staticRenderFns } from "./Page6.vue?vue&type=template&id=1d44b1da&scoped=true&"
import script from "./Page6.vue?vue&type=script&lang=ts&"
export * from "./Page6.vue?vue&type=script&lang=ts&"
import style0 from "./Page6.vue?vue&type=style&index=0&id=1d44b1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d44b1da",
  null
  
)

export default component.exports